// export const API_HOST = "http://localhost:3001/api/v1/";

// export const API_HOST = "https://kyc-dev.toothlens.com/api/v1/";

export const API_HOST = "https://kyc.toothlens.com/api/v1/";

// Toggle the patient-KYC dental ML/annotation. false = skip folder ML (KYC-only: stub report,
// no PDF, internal notification email). Set true to restore the original full-ML flow
// (folder ML + tl-star/store report save + dental-report PDF email).
export const KYC_ML_ENABLED = false;




